import React, { useState, useEffect } from "react";
import Classes from "../Profile.module.css";
import InterestDropDown from "./DropDowns/InterestDropDown";

export default function GoalsAndInterests({ data, update, onNext, onBack }) {
  const [form, setForm] = useState(data);
  useEffect(() => setForm(data), [data]);

  const textChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    update({ [name]: value });
  };
  const setArr = (key) => (val) => { setForm((p) => ({ ...p, [key]: val })); update({ [key]: val }); };

  const handleSubmit = (e) => { e.preventDefault(); onNext(); };

  return (
    <form className={Classes.infoCon} onSubmit={handleSubmit}>
      <div className={Classes.infoConMiddle}>
        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>What are Your Goals?</h5>
            <input
              name="goals"
              className={Classes.inputField}
              placeholder="Start a business, break into product design, etc."
              value={form.goals ?? ""}
              onChange={textChange}
              required
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>What are You Looking For In a Mentor?</h5>
            <input
              name="lookingFor"
              className={Classes.inputField}
              placeholder="Career advice, skill feedback, etc."
              value={form.lookingFor ?? ""}
              onChange={textChange}
              required
            />
          </div>
        </div>

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Areas of Interest</h5>
            <InterestDropDown selected={form.interest ?? []} onChange={setArr("interest")} />
          </div>
        </div>
      </div>

      <button type="submit" className={Classes.saveBtn}><h5>Next</h5></button>
    </form>
  );
}
